// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"65":"79e0b7b84b4e00f7","3892":"e6a6d0634400a066","9159":"1b1ce9ef96210c54"}[chunkId] + ".css";
};